// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner__container__3wcnK","spinner":"Spinner__spinner__3C2E-","sk-rotateplane":"Spinner__sk-rotateplane__31gsD","message":"Spinner__message__3gcq0"};